import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react';
import searchVehicleOnMap from '@iconify-icons/mdi/location-searching';
import '../../../../../src/assets/Styles/MapControlDispatchCSS/MapControlDispatch.css';
import ModuleSecurity from '../../../../utils/helpers/ModuleSecurity.js';


const VehicleDispatching = ({
  vehInfoArr = [],
  CloseVehCount = 0,
  vehData = [],
  onDispatchClick = async () => {},
  onVehicleItemClick = () => {},
  onVehicleZoomClick = () => {},
  dispatchingVehicleNo
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const sortedVehicles = vehInfoArr.flat().sort((a, b) => a.Dist - b.Dist);//[...vehInfoArr].sort((a, b) => a.Dist - b.Dist);
  const [loadingVehicle, setLoadingVehicle] = useState(null);


  const handleDispatch = async (vehNo) => {

    const match = vehData.find(v => String(v.VehNo) === String(vehNo));
    if (match) {
      try {
        await onDispatchClick({
          vehicleID: match.iVehicleID,
          driverID: match.iDriverID,
          vehNo: match.VehNo
        });
      } catch (error) {
        
      }
    }
  };

  useEffect (() => {

    return () => {
     
    }
  }, [])

  return (
    <div className="vehicle-dispatch-table">
    <input
      type="text"
      placeholder="Search vehicle or distance..."
      className="vehicle-search-input"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
    
    <div className='vehicleNo-card'>
      <label style={{
            fontSize: "14px",
            marginRight: "5px"
      }}>
        Total Vehicle(s):
      </label>
      <span
      className='span-VehicleDispatchCount'
     ><strong> {CloseVehCount}</strong></span></div>
    

    <div className="vehicle-list">
      {sortedVehicles
        .filter(veh =>
          veh.vehNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
          String(veh.Dist).toLowerCase().includes(searchTerm.toLowerCase())
        )
        .map((veh) => (
          <div key={veh.vehNo} className="vehicle-card"  onClick={() => onVehicleItemClick(veh)}>
            <div>
              <button
                  style={{width: "100%", padding: "0px", paddingLeft: "5px", paddingRight: "5px", paddingBottom: "2px"}}
                  id={`${veh.vehNo}_vehicleBtn`}
                  title={`Dispatch Vehicle #${veh.vehNo}`}
                  //onClick={() => handleDispatch(veh.vehNo)}
                  onClick={(e) => {
                    e.stopPropagation();
                    onVehicleZoomClick(veh);
                  }}
                  >
                  <Icon icon={searchVehicleOnMap} width="16" height="16" style={{color: 'white'}}/>
                </button>
            </div>
            <div className="vehicle-info">
                <label style={{ paddingRight: "20px"
                }}> Veh#:  <strong>{veh.vehNo}</strong></label>
                <label  style={{paddingRight: "5px"
                }}> Dist:  <strong>{veh.Dist}</strong></label>
             
              
            </div>
            <div style={{}}>
              {ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripAssignDispatch") && (
              <button
                style={{width: "100%"}}
                id={`${veh.vehNo}_vehicleBtn`}
                title={`Dispatch Vehicle #${veh.vehNo}`}
                //onClick={() => handleDispatch(veh.vehNo)}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDispatch(veh.vehNo);
                }}
                disabled={dispatchingVehicleNo  === veh.vehNo}
                >
               {dispatchingVehicleNo  === veh.vehNo ? (
                  <span>
                    <span className="spinner" /> Dispatching...
                  </span>) : 
                  ("Dispatch")
                }
              </button>
              )}
            </div>
          </div>
        ))}
    </div>
  </div>

  );
};

export default VehicleDispatching;

